import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { CurrentInfoService } from '@homeleite/domain';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(
    private currentInfo: CurrentInfoService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const info = await firstValueFrom(this.currentInfo.$value);
    if (!info) {
      return this.router.createUrlTree(['/login'], {
        queryParams: { src: btoa(state.url) },
      });
    }
    if (info.isAdmin) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return await this.canActivate(next, state);
  }
}
